import {
	useId,
	type InputHTMLAttributes,
	type LabelHTMLAttributes,
} from 'react'

import { ErrorList } from '#app/components/form/error-list.tsx'
import { type ListOfErrors } from '#app/components/form/types.ts'
import { Input } from '#app/components/ui/input.tsx'
import { Label } from '#app/components/ui/label.tsx'
import { cn } from '#app/utils/misc.tsx'

export function Field({
	labelProps,
	inputProps,
	descriptionProps,
	errors,
	className,
}: {
	labelProps: LabelHTMLAttributes<HTMLLabelElement>
	inputProps: InputHTMLAttributes<HTMLInputElement>
	descriptionProps?: LabelHTMLAttributes<HTMLParagraphElement>
	errors?: ListOfErrors
	className?: string
}) {
	const fallbackId = useId()
	const id = inputProps.id ?? fallbackId
	const errorId = errors?.length ? `${id}-error` : undefined
	return (
		<div className={cn('space-y-1.5', className)}>
			<Label htmlFor={id} {...labelProps} />
			<Input
				id={id}
				aria-invalid={errorId ? true : undefined}
				aria-describedby={errorId}
				{...inputProps}
			/>
			{descriptionProps && (
				<p
					{...descriptionProps}
					className={cn(
						'text-muted-foreground text-xs',
						descriptionProps.className,
					)}
				/>
			)}
			<div className="min-h-[16px]">
				{errorId ? <ErrorList id={errorId} errors={errors} /> : null}
			</div>
		</div>
	)
}
